
<div class="booking-dialog">

  <div class="content">
    <!-- {{data | json}}
    bk {{booking.carDayRate }} cr {{car.rentDayRate.amount}}
    cr2 {{car.offerId}}  -->
    <!--
    <h1 *ngIf="booking.id===0 && !isReschedule"> Nouvelle réservation  </h1>
    <h1 *ngIf="booking.id > 0 && !isReschedule"> Editer réservation </h1>
    <h1 *ngIf="isReschedule"> Proposer nouvelle date </h1> -->

    @if (booking.id===0 && !isModification && !isCompletion) {
      <h1> Créer réservation</h1>
    }
    @if (booking.id > 0 && !isModification && !isCompletion) {
      <h1> Editer réservation </h1>
    }
    @if (isModification && !isCompletion) {
      <h1> Modifier réservation</h1>
    }
    @if (isCompletion) {
      <h1> Compléter réservation</h1>
    }

    <form #bookingForm="ngForm" class="booking-form">

      <div class="booking-details">
        <div class="booking-details-data">
          <div>
            <h5><b>{{car.make}} {{car.model}} {{car.version}} </b> à partir de </h5>

            <h3 class="key-info">{{moneyFormat(""+booking.carDayRate)}} <span class="price-currency">{{booking.currency}} / jour </span></h3>
          </div>

          <div>
            <h5>Dates</h5>
            <mat-form-field>
              <!-- <mat-label> Dates </mat-label> -->
              <mat-date-range-input matInput [rangePicker]="picker2" [dateFilter]="filterPastDatesAndBookedDates" >
                <input required matStartDate placeholder="Début" name="start" (dateChange)="onSelectedDatesChange($event)" [(ngModel)]="booking.startDate" >
                <input required matEndDate placeholder="Fin" name="end" (dateChange)="onSelectedDatesChange($event)" [(ngModel)]="booking.endDate" >
              </mat-date-range-input>
              <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-date-range-picker #picker2></mat-date-range-picker>
            </mat-form-field>
          </div>

          <!--
          <button matButton class="cta-button" mat-button
            (click)="showBookingAddNew = !showBookingAddNew;"
            cdkOverlayOrigin #trigger="cdkOverlayOrigin">Ajouter<mat-icon>add</mat-icon>
          </button>
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="trigger"
            [cdkConnectedOverlayOpen]="showBookingAddNew">

            <div class="overlay-box">

              <mat-calendar
                [dateFilter]="filterPastDatesAndBookedDates"
                [selected]="selectedDateRange"
                (selectedChange)="onSelectedDateRangeChange($event!)"
                [dateClass]="dateClass">
              </mat-calendar>
              <button matButton class="simple-button"  mat-button (click)="showBookingAddNew = !showBookingAddNew; " ><b> Fermer </b><mat-icon>close</mat-icon></button>
              <button matButton class="simple-button"  mat-button (click)="addNewBooking();"><b> Reserver </b><mat-icon>save</mat-icon></button>

            </div>
          </ng-template> -->


          <div class="booking-details-data-item">
            <h5>Distance à parcourir</h5>
            <mat-radio-group name="mileageOption" (selectionChange)="onMileageOptionChange()" [(ngModel)]="booking.mileageOption" required>
              @for (option of mileageOptionsList; track option) {
                <mat-radio-button [value]="option.code">{{ option.desc }}</mat-radio-button>
              }
            </mat-radio-group>
          </div>
          <div>
            <h5>Assurance</h5>
            <mat-radio-group name="insuranceOption" (selectionChange)="onInsuranceOptionChange()" [(ngModel)]="booking.insuranceOption" required>
              @for (option of insuranceOptionsList; track option) {
                <mat-radio-button [value]="option.code">{{ option.desc }}</mat-radio-button>
              }
            </mat-radio-group>
          </div>

          <h5>Vous conduirez vous meme ?
            &nbsp;
            <mat-slide-toggle
              class="example-margin"
              name = "customerDriving"
              [disabled]="false"
              [(ngModel)]="booking.customerDriving"
              (change)="onCustomerDrivingChange() ">

            </mat-slide-toggle>
          </h5>

          @if (!booking.customerDriving) {
            <h5>Location avec Chauffeur ?
              &nbsp;
              <mat-slide-toggle
                class="example-margin"
                name = "withDriver"
                [disabled]="false"
                [(ngModel)]="booking.withDriver"
                (change)="onWithDriverChange() ">
              </mat-slide-toggle>
            </h5>
          }
          <!--
          <mat-checkbox name="withDriver"  class="example-margin" [(ngModel)]="booking.withDriver">Avec chauffeur</mat-checkbox>
          -->

        </div>

        <div class="summary-section">
          <div class="booking-detail-item"><h6>Véhicule ({{booking.getTotalDuration()}} x {{booking.carDayRate }}/J)</h6> <h6><b>{{moneyFormat(""+calculateCarAmount())}} {{booking.currency}}</b></h6></div>
          <div class="booking-detail-item"><h6>Assurance ({{booking.getTotalDuration()}} x {{booking.insuranceDayRate}}/J)</h6> <h6><b>{{moneyFormat(""+calculateInsuranceAmount())}} {{booking.currency}}</b></h6></div>
          @if (booking.withDriver) {
            <div class="booking-detail-item"><h6>Chauffeur ({{booking.getTotalDuration()}} x {{booking.driverDayRate}} {{booking.currency}}/J)</h6> <h6><b>{{moneyFormat(""+calculateDriverAmount())}} {{booking.currency}} </b></h6></div>
          }
          <mat-divider></mat-divider>
          <div class="booking-detail-item"><h5>Total</h5> <h5>{{moneyFormat(""+calculateTotalAmount())}} {{booking.currency}}</h5></div>
        </div>
      </div>
    </form>

    <div class="action-buttons">
      <button class="simple-button-rent" mat-button [mat-dialog-close]="">Annuler</button>
      <button class="cta-button-rent" [disabled]=!bookingForm.valid mat-button [mat-dialog-close]="booking" (click)="submitBooking();$event.stopPropagation()">
        Soumettre
      </button>
    </div>
  </div>
</div>